import React from 'react'

export const RightArrow = () => {
  return (
    <div className='rightarrow'>
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.1667 9.91668L21.25 17L14.1667 24.0833" stroke="#0F3557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
  )
}
